import { ErrorHandler, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideClientHydration } from '@angular/platform-browser';
import { MissingTranslationHandler, TranslateModule } from '@ngx-translate/core';
import { HIGHLIGHT_OPTIONS } from 'ngx-highlightjs';

import { LayoutsModule } from './layouts/layouts.module';
import { AppMissingTranslationHandler } from '@core/missing-translation.handler';
import { UniversalRelativeInterceptor } from '@core/services/universal-relative.interceptor';
import { HttpInterceptorService } from '@core/services/http-interceptor.service';
import { provideErrorHandler } from '@core/sentry-error-handler';

/**
 * Application-wide singletons and root configuration. Imported once, by AppModule.
 * Also carries what BwsCoreModule.forRoot() used to set up (animations, ngx-translate
 * root config) now that the shared library is compiled from source.
 */
@NgModule({
  imports: [
    LayoutsModule,
    TranslateModule.forRoot({
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: AppMissingTranslationHandler },
    }),
    RouterModule,
  ],
  providers: [
    // Eager animation engine. provideAnimationsAsync() was tried to keep it out of the
    // initial bundle, but it lazy-loads the engine and a component that binds an
    // animation callback — the forum thread's (@slideInPulse.done) — renders before the
    // engine arrives and throws NG05105. Correctness over the ~few kB saved.
    provideAnimations(),
    provideClientHydration(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: UniversalRelativeInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: HIGHLIGHT_OPTIONS,
      useValue: {
        config: {
          ignoreUnescapedHTML: true,
        },
        coreLibraryLoader: () => import('highlight.js/lib/core'),
        lineNumbersLoader: () => import('ngx-highlightjs/line-numbers'),
        languages: {
          html: () => import('highlight.js/lib/languages/xml'),
          css: () => import('highlight.js/lib/languages/css'),
        },
      },
    },
    { provide: ErrorHandler, useFactory: provideErrorHandler },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class CoreModule { }
